import { useQuery } from "react-query";
import { getUsageData } from "api/usage";
import ShimmerLoader from "components/shimmer-loader";
import getFormattedDate from "utils/methods/getFormattedDate";
import { ReactComponent as NotesIcon } from "assets/svgs/notes.svg";
import { ReactComponent as PatientIcon } from "assets/svgs/patient.svg";
import { ReactComponent as TemplateIcon } from "assets/svgs/template.svg";

const Usage = () => {
  const { data, isLoading } = useQuery("userUsage", getUsageData, {
    retry: false,
    staleTime: 10000,
  });

  const getDefaultTextIfAbsent = (envVal) => {
    if (!envVal || envVal === undefined) {
      return "";
    }
    return ` of ${envVal}`;
  };

  return (
    <div className="mb-12 mt-4 flex flex-wrap gap-5 xl:max-w-[850px]">
      <div className="flex min-w-[190px] flex-1 flex-col rounded-ns border border-solid border-rule bg-white px-5 py-4 shadow-card">
        <div className="h-12 mb-2">
          <PatientIcon />
        </div>
        <span className="font-body text-ui-sm text-muted">Patient Sessions</span>
        {isLoading ? (
          <ShimmerLoader className="w-8 h-8" />
        ) : (
          <>
            <span className="block h-8 font-display text-h4 font-medium text-ink">
              {data?.sessions || 0}
              {data?.isFreeTrial
                ? `${getDefaultTextIfAbsent(
                    process.env.REACT_APP_TRIAL_USER_LIMIT_SESSIONS || 60
                  )}`
                : ""}
            </span>
            {data?.isFreeTrial && data?.nextResetDate && (
              <span className="text-xs text-muted block mt-0.5">
                Resets {getFormattedDate(data.nextResetDate)}
              </span>
            )}
          </>
        )}
      </div>
      <div className="flex min-w-[190px] flex-1 flex-col rounded-ns border border-solid border-rule bg-white px-5 py-4 shadow-card">
        <div className="h-12 mb-2">
          <NotesIcon />
        </div>
        <span className="font-body text-ui-sm text-muted">Total Notes Created</span>
        {isLoading ? (
          <ShimmerLoader className="w-8 h-8" />
        ) : (
          <span className="block h-8 font-display text-h4 font-medium text-ink">
            {data?.notes || 0}
          </span>
        )}
      </div>
    </div>
  );
};

export default Usage;